import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { hamburgerHeader_GTM } from '../../gtm/datalayers/headerDataLayers.json';
import { fireGTM } from '../../gtm/gtmUtil';
import { logout_GTM } from '../../gtm/datalayers/utilDataLayers.json';
import languageDropdownIcon from '../languageDropdownIcon';
import { setCurrentLocale } from '../../store/actions';

// Function to set the locale in localStorage
const setLocaleInLocalStorage = (tenantName, locale) => {
  localStorage.setItem(`ME3_PERSISTENCE_LOCALE_${tenantName}`, locale);
};
class HamburgerMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      selectedLang: 'English',
    };
  }

  backgroundPrimary = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  selected = {
    color: `${
      this.props.tenant.name !== 'Baobab'
        ? this.props.tenant.primary
        : this.props.tenant.secondary
    }`,
    textDecoration: 'underline',
  };

  langOption = {
    color: `${
      this.props.tenant.name !== 'Baobab'
        ? this.props.tenant.primary
        : this.props.tenant.secondary
    }`,
  };

  setShowMenu = () => {
    fireGTM(hamburgerHeader_GTM.menu);
    this.setState((prevState) => {
      return {
        ...prevState,
        showMenu: !prevState.showMenu,
      };
    });
  };

  handleSearchClick = (dataLayerObj) => {
    fireGTM(dataLayerObj);
  };

  renderItem = (item) => (t) => {
    const menuItems = {
      careerSearch: (
        <div
          key={`${item}`}
          className="dropdown-item hamburger-item"
          id="career-search-link"
          data-cy="career-search-link"
          role="menuitem"
        >
          <Link
            to={`/${this.props.tenant.name.toLowerCase()}/career-search`}
            onClick={() =>
              this.handleSearchClick(hamburgerHeader_GTM.careerSearch)
            }
          >
            {t('Career Search')}
          </Link>
        </div>
      ),
      degreeSearch: (
        <div
          data-test-hamburger-item
          key={`${item}`}
          className="dropdown-item hamburger-item"
          id="degree-search-link"
          data-cy="degree-search-link"
          role="menuitem"
        >
          <Link
            to={`/${this.props.tenant.name.toLowerCase()}/degree-search`}
            onClick={() =>
              this.handleSearchClick(hamburgerHeader_GTM.degreeSearch)
            }
          >
            {t('Degree Search')}
          </Link>
        </div>
      ),
      ecap: (
        <div
          data-test-hamburger-item
          key={`${item}`}
          className="dropdown-item hamburger-item"
          id="action-plan-link"
          role="menuitem"
        >
          <Link
            data-cy="education-plan-link"
            to={`/${this.props.tenant.name.toLowerCase()}/education-plan`}
          >
            {t('Education and Career Action Plan')}
          </Link>
        </div>
      ),

      myPath2ASU: (
        <div
          data-test-hamburger-item
          key={`${item}`}
          className="dropdown-item hamburger-item"
          id="action-plan-link"
          role="menuitem"
        >
          <a
            href="https://webapp4.asu.edu/transfercreditguide/app/transfermap"
            rel="noopener noreferrer nofollow"
            target="_blank"
          >
            MyPath2ASU
          </a>
        </div>
      ),
      logout: (
        <div
          data-cy="hamburger-logout"
          key={`${item}`}
          className="dropdown-item hamburger-item hamburger-logout"
          tabIndex={0}
          onClick={() => this.logout()}
          role="menuitem"
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.logout();
          }}
        >
          {t('Logout')}
        </div>
      ),
      myDashboard: (
        <div
          data-test-hamburger-item
          key={`${item}`}
          className="dropdown-item hamburger-item"
          id="my-dashboard-link"
          role="menuitem"
        >
          <Link
            data-cy="my-dashboard-link"
            to={`/${this.props.tenant.name.toLowerCase()}/dashboard`}
          >
            {t('My Dashboard')}
          </Link>
        </div>
      ),
      advisorDashboard: (
        <div
          data-test-hamburger-item
          key={`${item}`}
          className="dropdown-item hamburger-item"
          id="advisor-dashboard-link"
          role="menuitem"
        >
          <Link
            data-cy="advisor-dashboard-link"
            to={`/${this.props.tenant.name.toLowerCase()}/advisor-dashboard`}
          >
            {t('Advisor Dashboard')}
          </Link>
        </div>
      ),
      translations: this.translationsSection(t),
    };

    return menuItems[item];
  };

  selectLanguage = (key, val) => {
    this.setState(
      {
        selectedLang: key,
      },
      () => {
        this.props.setCurrentLocale(val);
        setLocaleInLocalStorage(this.props.tenant.name.toLowerCase(), val);
      }
    );
  };

  get langOptions() {
    if (this.props.tenant.name === 'ASU') {
      return {
        English: 'en',
        Spanish: 'es',
      };
    }

    if (this.props.tenant.name === 'Baobab') {
      return {
        English: 'en',
        French: 'fr',
      };
    }

    return {};
  }

  translationsSection = (t) => {
    const currentLocale = localStorage.getItem('ME3_PERSISTENCE_LOCALE');
    return (
      <>
        <div
          data-test-hamburger-item
          key="Language"
          className="dropdown-item hamburger-item-language"
          id="action-plan-link"
        >
          <span className="lang-dropdown-btn-icon ham-menu-align-center">
            {languageDropdownIcon({
              sideLength: '24px',
              color: '#898989',
            })}
            {t(`Language`)}
          </span>
        </div>
        {Object.keys(this.langOptions).map((key, i) => {
          console.log('key', key, 'currentLocale', currentLocale);
          return (
            <div
              data-test-hamburger-item
              tabIndex={0}
              key={key}
              style={
                this.langOptions[key] === currentLocale
                  ? this.selected
                  : this.langOption
              }
              role="menuitem"
              className="dropdown-item hamburger-item"
              id="my-dashboard-link"
              onClick={() => {
                this.selectLanguage(key, this.langOptions[key]);
              }}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key))
                  this.selectLanguage(key, this.langOptions[key]);
              }}
            >
              {key}
            </div>
          );
        })}
      </>
    );
  };

  logout = async () => {
    try {
      fireGTM(logout_GTM, 'logout', this.props.gtmLocation);
      await Auth.signOut({ global: true });
    } catch (error) {
      console.error('could not log out: ', error.message);
    }
  };

  menu = (t) => (
    <div className="dropdown-menu" id="dropdown-menu" role="menu">
      <div className="dropdown-content">
        {this.props.listItems.map((item) => {
          return this.renderItem(item)(t);
        })}
      </div>
    </div>
  );

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="dropdown is-active is-right">
            <div className="dropdown-trigger">
              <button
                data-cy="hamburger-menu"
                className="hamburger-menu"
                type="button"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
                aria-expanded={this.state.showMenu}
                aria-label="dropdown menu"
                style={this.backgroundPrimary}
                onClick={() => this.setShowMenu()}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key)) this.setShowMenu();
                }}
              >
                <span>
                  <svg
                    width="35px"
                    fill="#ffffff"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    version="1.1"
                    x="0px"
                    y="0px"
                    role="img"
                  >
                    <title>Burger, hamburger, menu</title>
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        transform="translate(6.000000, 9.000000)"
                        fill="#ffffff"
                        fillRule="nonzero"
                      >
                        <path d="M0,8 L0,6 L20,6 L20,8 L0,8 Z M0,14 L0,12 L20,12 L20,14 L0,14 Z M0,2 L0,0 L20,0 L20,2 L0,2 Z" />
                      </g>
                    </g>
                  </svg>
                  {t('Menu')}
                </span>
              </button>
            </div>
            {this.state.showMenu ? this.menu(t) : null}
          </div>
        )}
      </Translation>
    );
  }
}

const HamburgerWithRouter = withRouter(
  connect(null, {
    setCurrentLocale,
  })(HamburgerMenu)
);

export default HamburgerWithRouter;

HamburgerMenu.propTypes = {
  tenant: PropTypes.object.isRequired,
  gtmLocation: PropTypes.string.isRequired,
  listItems: PropTypes.array.isRequired,
};
